function onlyWhitespaceInString(word: string): boolean {
  const regex = /^(?!\s*$).+/;
  return !regex.test(word);
}

export default onlyWhitespaceInString;
